import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { mapDivEnterToClick, setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';

import './PainScaleUI.css'

const numbers = [
	10,
	9,
	8,
	7,
	6,
	5,
	4,
	3,
	2,
	1,
	0
]

var currentFocus: string = null

const PainScaleUI = (props: PainScaleUIConfig) => {
	const [currentSelection, setCurrentSelection] = useState(10);
	const [isDragging, setIsDragging] = useState(false);
	const [yPos, setYPos] = useState(0);
	const updateSelection = (indx: number) => {
		setCurrentSelection(indx);
		if(props.selectionChanged) {
			props.selectionChanged(numbers[indx]);
		}
	}
	if(currentFocus) {
		setFocus(currentFocus)
	}
	return (
		<div className='modal-disable-select' onMouseMove={(event) => {
			if(isDragging) {
				var val = event.clientY - 400;

				if(val < 155 || val > 559) {
					return;
				}

				setYPos(val);
				var normalizedVal = val - 150;
				var percentage = (100 - ((normalizedVal / 374) * 100));
				if(percentage > 0 && percentage < 100) {
					var percentageNormalized = percentage / 100;

					if(percentageNormalized < 0.01) {
						updateSelection(numbers.length - 1);
					} else {
						updateSelection((numbers.length - 2) - parseInt(percentageNormalized.toString().split('.')[1][0]));
					}
				}
			}
		}}>
			<img style={{
				    position: 'absolute',
					top: '163px',
					left: '50%',
					width: '65px',
					transform: 'translate(-50%, 0)'
			}} src="./assets/images/general/components/pain-scale-ui/painslider_bar.png"/>

			{numbers.map((n: number, index: number) => {
				return (
					<div tabIndex={0} id={'pain-scale-' + index} aria-label={n.toString()} key={Tools.generateGuid()} style={{
						position: 'absolute',
						left: '50%',
						transform: 'translate(-50%, 0)',
						top: (180 + (index * 37)) + 'px',
						width: '60px',
						height: '44.81px'
					}} className="pointer" onKeyDown={(e) => {
						if (e.key === 'Tab' || e.which === 9) {
							currentFocus = 'pain-scale-';

							if(n === 0 || n === numbers.length - 1) {
								currentFocus = null;
							} else {
								if(e.shiftKey) {
									currentFocus += (index-1).toString()
								} else {
									currentFocus += (index+1).toString()
								}
							}
						}}
					} 
                    onKeyUp={mapDivEnterToClick}
					onClick={() => {
						setFocus(currentFocus)
						updateSelection(index);
						var clickAudio = document.getElementById('button-click');
						if(!globals.isMuted) {
							(clickAudio as any).play();
						}
					}}>
						{currentSelection === index ? <img style={{
							pointerEvents: 'none'
						}} src="./assets/images/general/components/pain-scale-ui/painslider_highlite.png"/> : (null)}
						<p style={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							margin: '0',
							transform: 'translate(-50%, -50%)'
						}} className="title-font">{n}</p>
					</div>
				)
			})}

			<div style={{
				width: '70px',
				height: '585px',
				position: 'absolute',
				left: '320px',
				top: '90px'
			}} onMouseDown={(event) => {
				setIsDragging(true);
				setYPos(event.clientY-400);
			}} onMouseOut={() => {
				setIsDragging(false);
			}}  onMouseUp={() => {
				setIsDragging(false);
			}}>
				
			</div>

			{!isDragging ? <div style={{
				position: 'absolute',
				top: 544 - ((numbers.length - (currentSelection + 1)) * 37) + 'px',
				left: '310px',
				pointerEvents: 'none'
			}} >
				<img style={{
					width: '85px',
					pointerEvents: 'none'
				}} src="./assets/images/general/components/pain-scale-ui/painslider_tab_main.png"/>
				<p style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					margin: '0',
					transform: 'translate(-50%, -50%)',
					pointerEvents: 'none'
				}} className="title-font">{numbers[currentSelection]}</p>
			</div> : (null)}

			{isDragging ? <div style={{
				position: 'absolute',
				top: yPos + 'px',
				left: '310px',
				pointerEvents: 'none'
			}}>
				<img style={{	
					width: '85px',
					pointerEvents: 'none'
				}} src="./assets/images/general/components/pain-scale-ui/painslider_tab_main.png"/>
				<p style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					margin: '0',
					transform: 'translate(-50%, -50%)',
					pointerEvents: 'none'
				}} className="title-font">{numbers[currentSelection]}</p>
			</div> : (null)}
		</div>
	);
};

export interface PainScaleUIConfig extends BaseConfig {
	selectionChanged: (painLevel: number) => void;
}
export default PainScaleUI;